/**
 * Internal dependencies
 */
import { WMUToggleClass } from "@wakemeup/toggle-class";
import ViewportManager from "./viewport-manager";

/**
 * 
 */
class BlockTabManager {

	/**
	 * 
	 */
	static modeIds = {
		ELASTIC: 'elastic',
		NAV: 'nav',
	};

	/**
	 * 
	 */
	constructor()
	{
		this.init();

		this.toggleGroupList = [];
		this.toggleSelector = ':scope > .block-list > .block-tab > .block-list > .block-tab-header';
		this.toggleTargetSelector = 'closest( .block-tab )';

		this.elasticScrollTimeoutID = null;
		this.elasticScrollPaddingBottom = 0;
		this.elasticScrollPaddingTop = 0;
	}

	/**
	 * 
	 */
	init()
	{
		this.onElasticScrollTimeout = this.onElasticScrollTimeout.bind( this );
		this.onElasticToggleOn = this.onElasticToggleOn.bind( this );
		this.onViewportChange = this.onViewportChange.bind( this );
		document.addEventListener( 'WMUViewportChange', this.onViewportChange );
	}

	/**
	 * 
	 */
	clear()
	{
		/**
		 * @todo Trouver une façon de ne pas clearer ceux dont le mode est identique entre le précédent viewport et le nouveau.
		 */
		this.toggleGroupList.forEach( ( toggleGroup ) =>
		{
			if ( BlockTabManager.modeIds.NAV === toggleGroup.wmuBlockTabMode && toggleGroup.wmuNavHeadersElement )
			{
				toggleGroup.wmuNavHeadersElement.remove();
			}

			toggleGroup.clear();
		} );

		this.toggleGroupList = [];
	}

	/**
	 * 
	 */
	setup()
	{
		/**
		 * @todo Faire en sorte de ne setup que les blocks qui ne sont pas déjà dans notre liste active. Ceci afin de permettre
		 *       de lancer cette fonction pour activer des blocks qui auraient été ajoutés dynamiquement.
		 */
		const elements = document.querySelectorAll( '.block-tab-group' );

		elements.forEach( ( element ) =>
		{
			const viewportCurrent = ViewportManager.viewportCurrent.toLowerCase();
			const mode = element.getAttribute( `${viewportCurrent}-mode` );

			switch ( mode )
			{
				default:
				case BlockTabManager.modeIds.NAV:
					this.setupElementNav( element );
					break;
				
				case BlockTabManager.modeIds.ELASTIC:
					this.setupElementElastic( element );
					break;
			}
		} );
	}

	/**
	 * 
	 */
	setupElementElastic( element )
	{
		const toggleGroup = WMUToggleClass.group( {
			groupElement: element,
			toggleSelector: this.toggleSelector,
			toggleArgs: {
				autoInit: false,
				targetSelector: this.toggleTargetSelector,
				fx: 'expand-collapse',
				fxTargetSelector: 'closest( .block-tab ):scope > .block-list > .block-tab-content',
			}
		} );

		toggleGroup.wmuBlockTabMode = BlockTabManager.modeIds.ELASTIC;
		this.toggleGroupList.push( toggleGroup );

		toggleGroup.addEventListener( 'toggleOn', this.onElasticToggleOn );
	}

	/**
	 * 
	 */
	setupElementNav( element )
	{
		const toggleGroup = WMUToggleClass.group( {
			groupElement: element,
			toggleSelector: this.toggleSelector,
			toggleArgs: {
				autoInit: false,
				targetSelector: this.toggleTargetSelector,
			}
		} );

		if ( toggleGroup.toggleList.length > 0 )
		{
			let index = 0;
			const headerElements = element.querySelectorAll( ':scope > .block-list > .block-tab > .block-list > .block-tab-header' );
			const navHeadersElement = document.createElement( 'div' );
			navHeadersElement.classList.add( 'nav-headers' );

			const viewportCurrent = ViewportManager.viewportCurrent.toLowerCase();
			let initTabIndex = element.getAttribute( `${viewportCurrent}-init-tab` );
			initTabIndex = ( null === initTabIndex || '' === initTabIndex ) ? 0 : Math.min( parseInt( initTabIndex ), toggleGroup.toggleList.length - 1 );

			/**
			 * Clone block-tab-header and set behaviors to control the linked toggle and sync its status
			 */
			headerElements.forEach( ( headerElement ) =>
			{
				const cloneElement = headerElement.cloneNode( true );
				cloneElement.wmuToggle = toggleGroup.toggleList[ index ];
				navHeadersElement.appendChild( cloneElement );

				cloneElement.addEventListener( 'click', ( event ) =>
				{
					// event.preventDefault();
					cloneElement.wmuToggle.toggleStatus();
				} );

				cloneElement.wmuToggle.addEventListener( 'setStatus', ( event ) =>
				{
					const status = event.detail.newStatus;
					const classOn = cloneElement.wmuToggle.getArg( 'classOn' );
					const classOff = cloneElement.wmuToggle.getArg( 'classOff' );
					const classesOn = ( classOn ) ? classOn.split( ' ' ) : [];
					const classesOff = ( classOff ) ? classOff.split( ' ' ) : [];

					if ( 'on' === status )
					{
						cloneElement.classList.remove( ...classesOff );
						cloneElement.classList.add( ...classesOn );
					}
					else
					{
						cloneElement.classList.remove( ...classesOn );
						cloneElement.classList.add( ...classesOff );
					}
				} );

				index++;
			} );

			element.prepend( navHeadersElement );
			toggleGroup.wmuNavHeadersElement = navHeadersElement;

			if ( -1 !== initTabIndex )
			{
				toggleGroup.toggleList[ initTabIndex ].setStatus( 'on' );
			}
		}

		toggleGroup.wmuBlockTabMode = BlockTabManager.modeIds.NAV;
		this.toggleGroupList.push( toggleGroup );
	}

	/**
	 * 
	 * @param {WMUToggleClass} toggle 
	 */
	onElasticScrollTimeout( toggle )
	{
		this.elasticScrollTimeoutID = null;

		const blockTabElement = toggle.toggleElement.closest( '.block-tab' );

		if ( blockTabElement )
		{
			const scroller = window;
			const blockTabRect = blockTabElement.getBoundingClientRect();
			const availableViewportTop = 0 + this.elasticScrollPaddingTop;
			const availableViewportHeight = scroller.innerHeight - ( this.elasticScrollPaddingBottom + this.elasticScrollPaddingTop );

			/**
			 * @todo Dans le script myblend mettre à jour la prop this.elasticScrollPaddingTop à partir de la hauteur de header
			 */
			let baseScrollY = scroller.scrollY;
			const stickyParent = blockTabElement.closest( `.${ViewportManager.viewportCurrent}-sticky` );

			if ( stickyParent )
			{
				let tallerSibling = null;

				// Search for the tallest sibling taller than the block tab sticky parent
				for ( let sibling of stickyParent.parentNode.children )
				{
					if ( sibling.clientHeight && sibling.clientHeight > stickyParent.clientHeight )
					{
						if ( null === tallerSibling || sibling.clientHeight > tallerSibling.clientHeight )
						{
							tallerSibling = sibling;
						}
					}
				}

				if ( tallerSibling )
				{
					const siblingRect = tallerSibling.getBoundingClientRect();
					const stickyRect = stickyParent.getBoundingClientRect();
					
					baseScrollY += siblingRect.bottom - stickyRect.bottom;
				}
			}

			// Enough space to display the whole tab
			if ( blockTabRect.height < availableViewportHeight )
			{
				if ( blockTabRect.top < availableViewportTop )
				{
					window.scrollTo( { top: blockTabRect.top + baseScrollY - availableViewportTop, left: 0, behavior: 'smooth' } );
				}
				else if ( blockTabRect.bottom > availableViewportHeight )
				{
					// window.scrollTo( { top: baseScrollY + ( blockTabRect.bottom - availableViewportHeight ), left: 0, behavior: 'smooth' } );
					window.scrollTo( { top: baseScrollY + ( blockTabRect.bottom - ( scroller.innerHeight + this.elasticScrollPaddingBottom ) ), left: 0, behavior: 'smooth' } );
				}
			}

			// Not enough space to display the whole tab
			else
			{
				window.scrollTo( { top: blockTabRect.top + baseScrollY - availableViewportTop, left: 0, behavior: 'smooth' } );
			}
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onElasticToggleOn( event )
	{
		if ( null !== this.elasticScrollTimeoutID )
		{
			clearTimeout( this.elasticScrollTimeoutID );
		}

		const toggle = event.detail.toggle;
		this.elasticScrollTimeoutID = setTimeout( this.onElasticScrollTimeout, 350, toggle );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onViewportChange( event )
	{
		this.clear();
		this.setup();
	}

}

export default BlockTabManager;